import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import DailyChartGrid from "../../Common/DailyChartGrid";
import i18next from "i18next";

class DailyChart extends Component {
    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.monthList.reset());
            await this.props.dispatch(this.props.yearList.reset());

            await this.props.dispatch(this.props.monthList.execute({}, {withParams: true, withStyle: true}));
            await this.props.dispatch(this.props.yearList.execute(this.props.monthListParams.getRow(0), {withStyle: true}));
        } catch (e) {
            console.error(e);
        }
    }

    applyParamsToYear = () => {
        this.props.dispatch(this.props.yearList.applyParams(this.props.monthListParams));
    };

    renderParams = (h) => {
        return (<div className="row">
            <div className="col-md-2">
                {/*График работы:*/}
                {h.lbl("TypeTabCalView")}
            </div>
            <div className="col-md-5">
                {h.ed("TypeTabCalView")}
            </div>

            <div className="col-md-1">
                {/*Год:*/}
                {h.lbl("NumYear")}
            </div>
            <div className="col-md-1">
                {h.ed("NumYear")}
            </div>
            <div className="col-md-1">
                {/*Месяц:*/}
                {h.lbl("MonthView")}
            </div>
            <div className="col-md-2">
                {h.ed("MonthView")}
            </div>
        </div>);
    };

    render() {
        let monthChartTitle = <></>;
        let yearChartTitle = <></>;
        if (this.props.monthListParams.dataTable().length === 1) {
            let params = this.props.monthListParams.getRow(0);
            monthChartTitle = <> {i18next.t("Schedule")} <span
                style={{color: "red"}}>{params.TypeTabCalView}</span> {i18next.t("DailyChart_MonthSchedulePlaceholder", {
                month: params.MonthView,
                year: params.NumYear.toString()
            })}</>;
            yearChartTitle = <> {i18next.t("Schedule")} <span
                style={{color: "red"}}>{params.TypeTabCalView}</span> {i18next.t("DailyChart_YearSchedulePlaceholder", {year: params.NumYear.toString()})}</>;
        }

        return (<React.Fragment>
            <PlaceholderWrapper placeholderId="10"
                                title={<><i className='fa fa-filter'/> {i18next.t("Schedule")}</>}
                                showSplitterLine={false}
                                canCollapse={false}
            >
                <ComplexParam dataItem={this.props.monthListParams}
                              readOnly={false}
                              showSearchBar={false}
                              showApplyButton={false}
                              autoApplyParams={true}
                              rootPath="/"
                              parentDataItem={this.props.monthList}
                              renderParams={this.renderParams}
                              afterApplyParams={this.applyParamsToYear}
                />
            </PlaceholderWrapper>

            <PlaceholderWrapper placeholderId="20"
                                title={<><i className='fa fa-table'/>{monthChartTitle}</>}
                                staticTitle={`${i18next.t('Schedule')} ${i18next.t("For_Period")} - 40`}
                                showSplitterLine={false}
                                canCollapse={false}>
                <DailyChartGrid dataItem={this.props.monthList}/>
            </PlaceholderWrapper>

            <PlaceholderWrapper placeholderId="30"
                                title={<><i className='fa fa-table'/>{yearChartTitle}</>}
                                staticTitle={`${i18next.t('Schedule')} ${i18next.t("For_Period")} - 30`}
                                showSplitterLine={false}
                                canCollapse={false}>
                <DailyChartGrid dataItem={this.props.yearList}/>
            </PlaceholderWrapper>
        </React.Fragment>);
    }
}

DailyChart.propTypes = {
    dispatch: PropTypes.func.isRequired,
    monthList: PropTypes.object,
    monthListParams: PropTypes.object,
    yearList: PropTypes.object,
};

DailyChart.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        monthList: state.dailyChartState.DailyChart_MonthList,
        monthListParams: state.dailyChartState.DailyChart_MonthListParams,
        yearList: state.dailyChartState.DailyChart_YearList
    }
}

export default connect(mapStateToProps)(DailyChart)